import React, { useRef } from 'react';

// style
import GlobalStyle from "../features/coupon/assets/styles/app";

// ui
import Header from '../features/coupon/components/Header';
import CheckUID from '../features/coupon/components/CheckUID';
import Form from '../features/coupon/components/Form';
import Footer from '../features/coupon/components/Footer';
import Seo from "../components/CommonSeo"

import { ModalProvider } from 'react-modal-hook';

const Page = () => {
    const scrollRef = useRef();

    return (
        <ModalProvider>
            <Seo />
            <GlobalStyle />
            <Header />
            <main>
                <Form scrollRef={scrollRef} />
                <CheckUID ref={scrollRef} />
            </main>
            <Footer />
        </ModalProvider>
    );
}

export default Page;